import React from 'react'
import cn from 'classnames'
import { observer } from 'mobx-react'

import TabStore from 'stores/tab/TabStore'
import TelemetryStore from 'stores/telemetry/TelemetryStore'

import Tooltip from 'components/tooltip/Tooltip'
import Button from 'components/button/Button'
import WhereFilterRow from './WhereFilterRow'

import styles from './whereFilter.scss'
import commonStyles from './common.scss'

interface IProps {}

interface IState {
  isOpen: boolean
}

class WhereFilter extends React.PureComponent<IProps, IState> {
  private button: React.RefObject<HTMLDivElement> = React.createRef()

  state: IState = {
    isOpen: false,
  }

  handleToggle = () => {
    this.setState(state => ({
      isOpen: !state.isOpen,
    }))
  }

  handleAddWhere = () => {
    TabStore.activeTab?.update({ preview: false })

    const script = TabStore.activeTab?.session!.script!

    script.update({ frozen: false })
    const where = script.where.add({
      fieldIds: [script.model.uniqueIdentifiers[0].id],
      value: null,
    })

    script.pagination.reset()
    // Not running script because a new where filter is always invalid

    TelemetryStore.send({
      command: 'filter_change',
      commandDetails: {
        total_filters_count: script.where.size,
        field_types: where.fields.map(f => f.type),
        operation: where.operation,
      },
    })
  }

  render() {
    const { isOpen } = this.state
    const { where } = TabStore.activeTab!.session!.script

    return (
      <div className={commonStyles.container}>
        <div
          data-cy="where-filter"
          ref={this.button}
          className={cn(commonStyles.pill, {
            [commonStyles.open]: isOpen,
            [commonStyles.exists]: where.size > 0,
          })}
          onClick={this.handleToggle}
        >
          {' '}
          <span className={cn(commonStyles.label)}>Filters</span>
          <span>{where.size || 'None'} </span>
        </div>
        {isOpen && (
          <Tooltip
            className={cn(styles.tooltip, { [styles.empty]: where.size === 0 })}
            target={this.button}
            onClickOutside={this.handleToggle}
          >
            <>
              {where.size === 0 && (
                <p className={styles.emptyText}>
                  Use filters to narrow down your data. Multiple filters show
                  results at their intersection (AND).
                </p>
              )}

              {Object.values(where.values).map(w => (
                <WhereFilterRow key={w.id} whereId={w.id} />
              ))}

              <Button
                data-cy="create-where-filter-btn"
                className={styles.addButton}
                blue
                onClick={this.handleAddWhere}
              >
                Add a new filter
              </Button>
            </>
          </Tooltip>
        )}
      </div>
    )
  }
}

export default observer(WhereFilter)
